import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPackageOut: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPackageOut"><Path d="M3.5 10.5V3.5H20.5V20.5H13.5" stroke="currentColor" strokeLinecap="square"/><Path d="M8.5 3.5V9.5H15.5V3.5" stroke="currentColor" strokeLinecap="square"/><Path d="M9.5 20.5V18.5C9.5 17.3954 8.60457 16.5 7.5 16.5H3M4.5 14.5L2.5 16.5L4.5 18.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconPackageOut;
